import _ from 'lodash';

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';

import Map from '../../shared/components/Map';

import { Button, Spin, Icon, Tooltip, Switch } from 'antd';

import { ActionButton } from '../../shared/components/ActionButton';

import {setBounds, setCenter} from '../../shared/actions';
import { setFenceUpdated, serverMarkPOIValidationStageComplete, serverMarkPOIUnsure } from '../actions';

import { resetPOI, serverLoadPOI, serverCreateFence } from '../../pois/actions';

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const green = '#03DAC4';
const yellow ='#F0DA3B';

class ValidationFixOnPremise extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            replaceGeofence: false,
            editGeofence: true,
            updatedFence: null,
            
            showAllFences: false,
        }

        this.onFenceVisibilityToggle = this.onFenceVisibilityToggle.bind(this);
    }
    componentDidMount(){
        let poiId = this.props.match.params.poi_id;
        this.context.mixpanel.time_event('validation', {
            task: 'fixOnPremise',
            poiId,
        });
    }

    componentWillUnmount(){
        this.context.mixpanel.track('validation');
    }

    componentWillMount(){
        let poiId = this.props.match.params.poi_id;
        this.props.getPoi(poiId);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.poi_id !== this.props.match.params.poi_id) {
            this.resetPOI();
            let poiId = nextProps.match.params.poi_id;
            nextProps.getPoi(poiId);
        }
    }

    onFenceVisibilityToggle(checked){
        this.setState({
            showAllFences: checked,
        });
    }

    onFenceToggle(){
        this.setState({
            editGeofence: !this.state.editGeofence,
            replaceGeofence: !this.state.replaceGeofence,
        });
    }

    resetPOI(){
        let poiId = this.props.match.params.poi_id;
        this.setState({
            replaceGeofence: false,
            editGeofence: true,
            updatedFence: null,
        });
        this.props.getPoi(poiId);
    }

    onNewGeoFence(geo){
        const poiId = this.props.match.params.poi_id;
        this.props.drawNewFence(poiId, geo.geometry);
        this.setState({
            replaceGeofence: false,
            editGeofence: true,
            updatedFence: null,
        });
    }
    
    render(){
        const {props, state} = this;
        const self = this;

        let fences = [];
        let poiId = props.match.params.poi_id;

        const tmp = props.poiInfo.get(poiId);

        if (_.isUndefined(tmp)) {
            return(
                <div style={{ textAlign: 'center', verticalAlign: 'center', paddingTop: '30%' }}>
                    <Spin indicator={antIcon} />
                </div>
            )
        }
        const poi = tmp.poi;
        const pois = [poi];

        if (state.showAllFences) {
            fences = [...tmp.fences];
        } else {
            if (tmp.fences.length > 0) {
                fences = [tmp.fences[0]];
            }
        }

        return(
            <div style={{ width: '100%', height: '100%', padding: '15px 20px', overflowY: 'scroll' }}>
                <div style={{ padding: '10px 0px' }}>
                    <Switch checked={this.state.showAllFences} onChange={this.onFenceVisibilityToggle} />
                </div>
                <div style={{width: '100%', height: '50vh'}}>
                    <Map {...props} pois={pois}
                        drawOnlyTopFence={false} fences={state.replaceGeofence ? [] : fences}
                        showGeocode={false}
                        editMode={state.editGeofence}
                        drawMode={state.replaceGeofence}
                        newFenceDrawn={this.onNewGeoFence.bind(this)}
                        onFenceUpdate={(updatedFence) => {
                            self.setState({
                                updatedFence,
                            });
                        }}
                    />
                </div>
                {state.updatedFence !== null ? (
                    <div className="highlighted-area">
                        <h4 className="heading-level-3">Geofence Updated</h4>
                        <div style={{ marginTop: 5}}>
                            <Button type="primary" style={{ marginRight: 5 }} onClick={() => {
                                props.updateFence(poiId, fences[0]._id, state.updatedFence);
                                self.setState({
                                    updatedFence: null,
                                });
                            }}>Save Changes</Button>
                            <Button type="danger" onClick={this.resetPOI.bind(this)}>Discard Changes</Button>
                        </div>
                    </div>
                ) : null}
                <div style={{ padding: "0px 0px 10px 0px" }}>
                    <span className="field">
                            <span className="label">POI name</span>
                            <h4 className="heading-level-2">
                                <a onClick={(e) => {
                                    e.preventDefault();
                                }}>{`${poi.organizationName} > ${poi.name}`}</a>
                            </h4>
                        </span>
                    <p className="inline-content">{poi.formattedAddress}</p>
                </div>
                <div>
                    <Tooltip placement="topLeft" title="Revert back to the original geofence" autoAdjustOverflow={false}>
                        <Button type={"default"}
                                style={{ marginRight: 5 }} onClick={this.resetPOI.bind(this)}>
                            Reset Geofence
                        </Button>
                    </Tooltip>
                    <Tooltip placement="topLeft" title="Drag the white polygon ‘points’ to edit the geofence" autoAdjustOverflow={false}>
                        <Button type={state.editGeofence ? "primary" : "default"}
                                disabled={state.editGeofence || fences.length === 0}
                                style={{ marginRight: 5 }} onClick={this.onFenceToggle.bind(this)}>
                            Edit Geofence
                        </Button>
                    </Tooltip>
                    <Tooltip placement="topLeft" title="Use the crosshairs to completely redraw the geofence polygon" autoAdjustOverflow={false}>
                        <Button type={state.replaceGeofence ? "primary" : "default"}
                                disabled={state.replaceGeofence}
                                onClick={this.onFenceToggle.bind(this)}>
                            Redraw Geofence
                        </Button>
                    </Tooltip>
                </div>
                <div className="button-group">
                    <ActionButton 
                        style={{ backgroundColor: yellow}}
                        onClick={() => {
                            props.markPOIUnsure(poiId);
                        }}>
                        Unsure
                    </ActionButton>
                    
                    <ActionButton
                        disabled={fences.length === 0}
                        style={{ backgroundColor: green}}
                        onClick={() => {
                            props.markAsValidated(poiId);
                        }}>
                        Correct
                    </ActionButton>
                </div>
            </div>
        )
    }
}


ValidationFixOnPremise.propTypes = {
  fencesMap: PropTypes.instanceOf(Immutable.Map),
  match: PropTypes.shape({
    params: PropTypes.shape({
      'poi_id': PropTypes.string,
    })
  }),
  duplicatePois: PropTypes.array,
  setMapBounds: PropTypes.func,
  setCenter: PropTypes.func,
  getPoi: PropTypes.func,
  drawNewFence: PropTypes.func,
  updateFence: PropTypes.func,
  markAsValidated: PropTypes.func,
  markPOIUnsure: PropTypes.func,
  poiInfo: PropTypes.instanceOf(Immutable.Map),
}

ValidationFixOnPremise.contextTypes = {
    mixpanel: PropTypes.object.isRequired,
};

// Map props to the store

const mapStateToProps = (state) => ({
  mapCenter: state.common.getIn(['center']),
  mapBounds: state.common.getIn(['bounds']),
  fencesMap: state.routes.validation.get('fencesMap'),
  poiInfo: state.routes.pois.server.get('poisMap'),
  drawMode: true,
  editMode: true,
  draggableMarkers: false,
  key: 'fenceEditMap',
});

const mapDispatchToProps = (dispatch) => ({
  newFenceDrawn: (newFence)=>{
    dispatch(setFenceUpdated({
      type: newFence.geometry.type,
      coordinates: newFence.geometry.coordinates,
    }));
  },
  centerChanged: ()=>{
    dispatch(setCenter(null));
  },
  setCenter: (center)=>{
      dispatch(setCenter(center));
  },
  setMapBounds: (bounds)=>{
    dispatch(setBounds(bounds));
  },
  getPoi: (poiId)=>{
    dispatch(resetPOI(poiId));
    dispatch(serverLoadPOI(poiId));
  },
  drawNewFence: (poiId, geo) => {
    dispatch(serverCreateFence(poiId, geo, 3));
  },
  updateFence: (poiId, fenceId, geo) => {
    dispatch(serverCreateFence(poiId, geo, 3));
  },
  markAsValidated: (poiId) => {
      dispatch(serverMarkPOIValidationStageComplete(poiId, 'fixOnPremise'));
  },
  markPOIUnsure: (poiId) => {
      dispatch(serverMarkPOIUnsure(poiId));
  },
})

const ValidationFixOnPremiseContainer = connect(mapStateToProps,mapDispatchToProps)(ValidationFixOnPremise);

export default ValidationFixOnPremiseContainer;


// WEBPACK FOOTER //
// ./src/validation/components/ValidationFixOnPremise.js